import React from 'react';
import {useI18n} from "../../i18n";

interface Props {
    art: string;
    small?: boolean,
    handleImageError?: (e: any) => void;
}
const SongArt = ({art, small = false, handleImageError}: Props) => {
    const {t} = useI18n();

    return (
        <img
            src={art}
            alt={t('components.songArt.userAlt')} className={`${ small ? 'w-[20px]' : 'w-auto'} h-auto mr-3 song_art_sm`}
            onError={handleImageError}
        />
    );
};

export default SongArt;
